import * as React from 'react';
import { useActions } from '../workspaceSettingActions';
import { useAlert } from '../../Alert/alert';
import { Toggler } from '../../Toggler/toggler';
import { useSelector } from '../../../utils/useSelector';
import TooltipPopover from '../../Popover/popover';
import { Info } from 'rcd-cpp-ui/ui/icon';

export const BacktaggingSettings = () => {
  const backtaggingWindowOpen = useSelector(s =>
    s.planning?.selectedWorkspace?.setting?.props?.backtaggingWindowOpen
      ? true
      : false
  );
  const lockStagedMetadata = useSelector(s =>
    s.planning?.selectedWorkspace?.setting?.props?.lockStagedMetadata
      ? true
      : false
  );
  const { save, Alert } = useAlert(useActions());

  return (
    <div className="ws-setting-content default-data scrollable">
      <Alert />
      <h6 className="ws-setting-desc">Backtagging metadata</h6>
      <div className="bts">
        <Toggler
          label="Backtagging window open"
          checked={backtaggingWindowOpen}
          onChange={val => {
            if (val !== true) {
              save({ backtaggingWindowOpen: val, lockStagedMetadata: true });
            } else {
              save({ backtaggingWindowOpen: val });
            }
          }}
        >
          <TooltipPopover
            packed={true}
            type="info"
            pointerPosition="top"
            content={`Opening the backtagging window enables the backtagging views for all users`}
          >
            <Info />
          </TooltipPopover>
        </Toggler>
      </div>
      <div>
        <Toggler
          label="Lock staged metadata"
          checked={lockStagedMetadata}
          onChange={val => save({ lockStagedMetadata: val })}
          disabled={backtaggingWindowOpen !== true}
        />
      </div>
    </div>
  );
};
